import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { ChangeBankAccountStepper } from '@/Contract/ui/organisms'
import { PageWrapper } from '@/Shared/ui/layout'
import { useUserData } from '@/User/ui/context'

export const ChangeBankAccountPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  const location = useLocation()

  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={location.state?.origin}
    >
      <PageWrapper paddingSmaller>
        <OreHeading as="h1" size="title-md">
          {t(contractTranslation.changeBankAccount.pageTitle)}
        </OreHeading>
        <OreDivider space="medium" />
        <OreStack space="large" placeContent="stretch">
          <OreText>{ merchant.isNursery ? t(contractTranslation.changeBankAccount.introductionGuarderia) : t(contractTranslation.changeBankAccount.introduction)}</OreText>
          <ChangeBankAccountStepper />
        </OreStack>
      </PageWrapper>
    </AccountProvider>
  )
}
